import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { SortService,ToolbarService, FilterService,EditSettingsModel,EditService , ReorderService, TreeGridComponent, ToolbarItems, Column } from '@syncfusion/ej2-angular-treegrid';
import { GridComponent, IEditCell, RowSelectEventArgs } from '@syncfusion/ej2-angular-grids';

import { ApiService } from 'src/app/_services/api.service';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { v4 as uuidv4 } from 'uuid';
import { GlobalService } from 'src/app/_services/global.service';
import { Query, DataManager, UrlAdaptor } from '@syncfusion/ej2-data';
import { AutoCompleteComponent } from '@syncfusion/ej2-angular-dropdowns';
import { forkJoin } from 'rxjs';



@Component({
  selector: 'app-arkiwebroles',
  templateUrl: './arkiwebroles.component.html',
  styleUrls: ['./arkiwebroles.component.css'],
  providers: [FilterService, SortService,ToolbarService, ReorderService,EditService,MessageService],
  encapsulation: ViewEncapsulation.None,
})

export class ArkiwebrolesComponent implements OnInit {
  @ViewChild(TreeGridComponent, { static: false }) treegrid: TreeGridComponent;
  @ViewChild('gridusers') public gridusers?: GridComponent;

  operatoriList=[
    '=','>','<','>=','<=','IN','NOT IN'
  ];
  modalitaList=['ABILITATO','SOLO LETTURA','DISABILITATO'];
  appList:any[]=[];

public editSettings2?: EditSettingsModel;

  public searchSettings?: Object;
  usersRoleList:any[]=[];
  toolbarUsersRoleOptions?: string[];
  showDialogUsersRole:boolean=false;
  crole:string='';

  toolbarOption?: string[];
  editSettings: EditSettingsModel;
  rolesList:any[]=[];
  showDialogRole:boolean=false;
 
  cid:any;
  roleName:string='';
  roleDescription:string='';
  roleappsList:any[]=[];
  selectedrecords:any[]=[];
  appsList:any[]=[];
  lastModifiedUser:string='';
  lastModifiedDate:Date=null;


  constructor(
    private apiService: ApiService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private globalService: GlobalService
  ) {}

  ngOnInit(): void {

    this.apiService.get('organizationchart/getapps',{}).subscribe((data)=>{
      this.appList=[];
      data.Result.forEach((d)=>{
        this.appList.push({
          value:d.app_id,
          label:d.name
        });
      });
    });
    
    this.editSettings2 = { allowEditing: true, allowAdding: true, allowDeleting: true};

    this.rolesList=[
      {
        id:1,
        node:'Ruoli',
        childs:[]
      }
    ];
    let apps=this.apiService.get('organizationchart/getapps',{});
    let roles=this.apiService.get('organizationchart/getroles',{});
    this.toolbarOption = ['Search'];
    this.toolbarUsersRoleOptions= ['Search'];
    this.searchSettings = { hierarchyMode:  'Child' };
    this.rolesList=[];
    forkJoin([ apps,roles]).subscribe(data => {
      this.appsList=data[0].Result.filter((a)=>a.active);
   
      this.appsList.sort((a, b) => a.app_id < b.app_id ? -1 : a.app_id > b.app_id ? 1 : 0);
      
      this.rolesList=data[1].Result;

      
      this.rolesList.sort((a, b) => a.node < b.node ? -1 : a.node > b.node ? 1 : 0);

      this.treegrid.dataSource=[];
      setTimeout(()=>{
        this.treegrid.dataSource=this.rolesList;
      },1000);
    });

    this.editSettings ={ allowEditing: true, allowAdding: false, allowDeleting: false, mode:"Cell", newRowPosition: 'Child'}; 

  }

  removerowapp(ap){
    this.roleappsList.forEach((r,ind)=>{
      if(r.id==ap.id)
         this.roleappsList.splice(ind, 1);
    });
  }

  removeNode(data){
    this.rolesList.forEach((r,ind)=>{
      if(r.id==data.id)
         this.rolesList.splice(ind, 1);
    });
    this.treegrid.dataSource=[];
    setTimeout(()=>{
      this.treegrid.dataSource=this.rolesList;
    },1000);
  }
  
  saveRoleToTreeGrid(){
    
    let childs=[];
    
    this.roleappsList.forEach((ap)=>{
      let desc=ap.access;
      if(ap.property_name){
        desc+=' '+ap.property_name+' '+ap.property_operator+' '+ap.property_value
      }
      childs.push({
          id:uuidv4(),
          app_id:ap.app_id,
          node:this.appList.filter((x)=>x.value==ap.app_id)[0].label,
          description:desc,
          access:ap.access,
          property_name:ap.property_name,
          property_value:ap.property_value,
          property_operator:ap.property_operator,
          childs:[]
        });
    });
    if(this.cid){
      this.rolesList.forEach((ap,ind)=>{   
        if(ap.id==this.cid){
          this.rolesList[ind].node=this.roleName;
          this.rolesList[ind].description=this.roleDescription;
          this.rolesList[ind].childs=childs;
        }
      });
    } else {
      this.cid=null;
      let newNode={
        node:this.roleName,
        description: this.roleDescription,
        childs:childs
      };
      this.rolesList.unshift(newNode);  
    }
   
    this.treegrid.dataSource=[];
    this.showDialogRole=false;
    setTimeout(()=>{
      this.treegrid.dataSource=this.rolesList;
    },100);
  }

  rowSelected(args: RowSelectEventArgs) {
    this.selectedrecords= (this.treegrid as TreeGridComponent).getSelectedRecords();  // Get the selected records.
  }

  saveAllRoles(){
    this.rolesList.forEach((r,ind)=>{
      r.childs.forEach((a,inda)=>{
      
        if(!a.properties){
          this.rolesList[ind].childs[inda].properties='';
        }
      });
    });
    let params={
      user_id:this.globalService.loggedUser.id,
      rolesList:this.rolesList
    };
   

    this.apiService.get('organizationchart/updinsrole',params).subscribe(data => {
      this.addSingle('success', 'Successo', 'Elenco Permessi salvato');
    });

    

  }
  
  actionComplete(args): void {
  }
  
  updateNode(node:any,newNode:any){
   
  }
  

  editNode(data){
    this.showDialogRole=true;
    this.cid=data.id;
    this.roleName=data.node;
    this.roleDescription=data.description;
    this.roleappsList=data.childs;
 
  }

  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }

  addabilitazione(){
    this.roleappsList.push({
    });
  }
}
